import React, { useState } from 'react'
import { Box, Modal, Typography } from '@mui/material'
import { Button, Col, Container, FloatingLabel, Form, InputGroup, Row } from 'react-bootstrap';
import { ErrorSharp } from '@mui/icons-material';
import { editarRegistroAdministradores } from '@helpers/httpRequests/httpRequestAccesos/httpRequestAccesos';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


const EditarRegistro = ({handleCancelarEdicion, infoRegistro, verModalEdicion, setRegistroModificado}) => {

    const {cuenta, nombreCuenta, acceso, usuario, clave, anotaciones, idRegistro} = infoRegistro;

    const [formValues, setFormValues] = useState({
        idRegistro,
        cuenta,
        nombreCuenta,
        acceso,
        usuario,
        clave,
        anotaciones,
    });

    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => setShowPassword(!showPassword);

    const handleOnChange = ({currentTarget}) => {
        const {name, value} = currentTarget;

        setFormValues({
            ...formValues,
            [name]: value
        })
    }

    const handleSubmit = async(e) =>{
        e.preventDefault();
        try {
            const {cuenta, nombreCuenta, acceso, usuario, clave, anotaciones, idRegistro} = formValues;

            await editarRegistroAdministradores({
                cuenta,
                nombreCuenta,
                acceso,
                usuario,
                clave,
                anotaciones,
                idRegistro
            });

            setRegistroModificado(true);
            handleCancelarEdicion();
            
        } catch (error) {
            console.log(error);
        }
    }

  return (
    <Modal
            open={verModalEdicion}
            onClose={handleCancelarEdicion}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Container>
                    <Row className="mt-4">
                        <Col>
                            <Form onSubmit={handleSubmit}>

                                <Row>
                                    <Col>
                                        <Form.Label htmlFor="cuenta">Cuenta</Form.Label>
                                        <Form.Control
                                            autoComplete='off'
                                            list='suggestions'
                                            className="mb-3"
                                            name="cuenta"
                                            value={formValues.cuenta}
                                            onChange={handleOnChange}
                                            type="text"
                                            id="cuenta"
                                            placeholder="Global click"
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Label htmlFor="nombreCuenta">Nombre de la cuenta</Form.Label>
                                        <Form.Control
                                            autoComplete='off'
                                            list='suggestions'
                                            className="mb-3"
                                            name="nombreCuenta"
                                            value={formValues.nombreCuenta}
                                            onChange={handleOnChange}
                                            type="text"
                                            id="nombreCuenta"
                                            placeholder='Ejemplo: Víctor Manuel Méndez'
                                        />
                                    </Col>
                                </Row>

                                <Form.Label htmlFor="acceso">Acceso</Form.Label>
                                <Form.Control
                                    autoComplete='off'
                                    list='suggestions'
                                    className="mb-3"
                                    name="acceso"
                                    value={formValues.acceso}
                                    onChange={handleOnChange}
                                    type="text"
                                    id="acceso"
                                    placeholder='Ejemplo: https://cursos.globalclickmexico.com/login'
                                />

                                <Form.Label htmlFor="usuario">Nombre de usuario</Form.Label>
                                <Form.Control
                                    autoComplete='off'
                                    list='suggestions'
                                    className="mb-3"
                                    name="usuario"
                                    value={formValues.usuario}
                                    onChange={handleOnChange}
                                    type="text"
                                    id="usuario"
                                />

                                <Form.Label htmlFor="inputPassword5">Contraseña</Form.Label>
                                <Form.Control
                                    className="mb-3"
                                    name="clave"
                                    value={formValues.clave}
                                    onChange={handleOnChange}
                                    type={showPassword ? 'text' : 'password'}
                                    id="inputPassword5"
                                    aria-describedby="passwordHelpBlock"
                                />
                                <span style={{ cursor: 'pointer'}} onClick={handleShowPassword} className="mb-4">{showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}</span>

                                <FloatingLabel className="mt-3 mb-3" controlId="anotaciones" label="Anotaciones">
                                    <Form.Control
                                        name="anotaciones"
                                        value={formValues.anotaciones}
                                        onChange={handleOnChange}
                                        as="textarea"
                                        placeholder="Anotaciones de la cuenta"
                                        style={{ height: '100px' }}
                                    />
                                </FloatingLabel>


                                <div className='d-grid gap-2 mt-3'>
                                    <Button type="submit" className='btn btn-success'>Guardar</Button>
                                </div>
                            </Form>

                        </Col>
                    </Row>
                </Container>
            </Box>
        </Modal>
  )
}

export default EditarRegistro